const getMiddleFrameIndex = (metadata) => {
	if (!metadata?.length) {
		return -1;
	}

	return Math.floor(metadata.length / 2);
};

export default getMiddleFrameIndex;
